import { ToolPageShell } from '@/shared/seo'
import { PostavitParolNaPdfForm } from './PostavitParolNaPdfForm'

export function PostavitParolNaPdfPage() {
  return (
    <ToolPageShell utilityKey="protect-pdf">
      <PostavitParolNaPdfForm />
    </ToolPageShell>
  )
}
